import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import jobActions from '../../../actions';
import bookingActions from '../actions';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import Api from '../../../../../../helpers/api';
import { keyByProperty } from '../../../../../../helpers/core';

const api = new Api('shifts/:id/resolve_contested_time');
const processApi = new Api('shifts/:id/resolve_contested_time?payment=1');

function* updateResolvedHours({ payload }) {
  try {
    const { editForm, id, jobId, process, pages } = payload;

    const propsArray = Object.values(editForm);
    const shift = keyByProperty(propsArray, 'name', prop => prop.value);

    const result = yield call(
      sendRequest,
      process ? processApi.updateItem : api.updateItem,
      { data: { shift }, id },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      if (result.data) {
        yield put(actions.saveSuccess());
        yield put(bookingActions.closeResolveHoursModal());

        if (jobId) {
          yield put(jobActions.loadData({ id: jobId, pages }));
        }
      } else {
        yield put(actions.saveError({ data: result }));
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.UPDATE, updateResolvedHours)]);
}
